import React, { FunctionComponent } from "react";

import { bemClassNames, createQA } from "@multiweb/reactUtils";
import { QAProps } from "@multiweb/types/react";

export type MountHtmlElementProps = {
    /** Html element k vyrenderovnání do komponenty */
    htmlElement: HTMLElement;
    /** Výška vkládaného elementu. */
    height?: number | string;
    /** Šířka vkládaného elementu. */
    width?: number | string;
    /** Velikost prvku ve flex rozložení. */
    flexGrow?: number;
} & QAProps;

const className = bemClassNames("mount-html-element-component");

export const MountHtmlElement:FunctionComponent<MountHtmlElementProps> = ({
    htmlElement,
    height,
    width,
    flexGrow,
    qa,
}) => (
    <div
        className={className()}
        ref={ref => {
            if (!ref) {
                return;
            }
            ref.appendChild(htmlElement);
        }}
        style={{
            height,
            width,
            flexGrow,
        }}
        {...createQA(qa)}
    />
);
